module.exports = __webpack_public_path__ + "static/img/htmb-min.767750a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/htmb-min.jpg
// module id = 3nZN
// module chunks = 1